import type { MembershipsBadgesApi } from '@fourthwall/services/dist/MembershipsBadgesApiClient'

import type { FormValues } from './hooks/useBadgeForm/types'

export const getRulesPayload = (
  values: FormValues,
): MembershipsBadgesApi.CreateCustomBadge.RequestBody['rules'] => {
  const rules: MembershipsBadgesApi.CreateCustomBadge.RequestBody['rules'] = []

  if (!values.canBeEarnedByMembers) return undefined

  values.rules.forEach((rule) => {
    if (rule.type === 'CommentsWritten') {
      rules.push({
        type: 'CommentsWritten',
        minimum: values.commentsWrittenMin ? parseInt(values.commentsWrittenMin) : 0,
        maximum: values.commentsWrittenMax ? parseInt(values.commentsWrittenMax) : undefined,
      })
    }

    if (rule.type === 'LikesGiven') {
      rules.push({
        type: 'LikesGiven',
        minimum: values.likesGivenMin ? parseInt(values.likesGivenMin) : 0,
        maximum: values.likesGivenMax ? parseInt(values.likesGivenMax) : undefined,
      })
    }

    if (rule.type === 'LikesReceived') {
      rules.push({
        type: 'LikesReceived',
        minimum: values.likesReceivedMin ? parseInt(values.likesReceivedMin) : 0,
        maximum: values.likesReceivedMax ? parseInt(values.likesReceivedMax) : undefined,
      })
    }

    if (rule.type === 'GiftsGiven') {
      rules.push({
        type: 'GiftsGiven',
        minimum: values.gifsGivenMin ? parseInt(values.gifsGivenMin) : 0,
        maximum: values.gifsGivenMax ? parseInt(values.gifsGivenMax) : undefined,
      })
    }

    if (rule.type === 'FirstSubscribedAt') {
      rules.push({
        type: 'FirstSubscribedAt',
        firstSubscribedAtFrom: values.firstSubscribedAtFrom,
        firstSubscribedAtTo: values.firstSubscribedAtTo,
      })
    }

    if (rule.type === 'ActiveMemberAt') {
      rules.push({
        type: 'ActiveMemberAt',
        activeMemberAtFrom: values.activeMemberAtFrom,
        activeMemberAtTo: values.activeMemberAtTo,
      })
    }
    if (rule.type === 'Tier' && rule.tierId) {
      rules.push({
        type: 'Tier',
        tierId: rule.tierId,
      })
    }
  })

  return rules.length > 0 ? rules : undefined
}

export const getIconPayload = (
  emoji: FormValues['emoji'],
): MembershipsBadgesApi.CreateCustomBadge.RequestBody['icon'] => {
  if (emoji.type === 'Emoji') {
    return {
      type: 'Emoji',
      emojiIcon: emoji.emojiIcon,
    }
  }

  return {
    type: 'ImageResource',
    id: emoji.imageResourceId!,
  }
}
